module.exports = "<div *ngIf=\"shown\">\r\n  <div class=\"igo-spinner-background\"></div>\r\n  <mat-progress-spinner diameter=\"40\" mode=\"indeterminate\"></mat-progress-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/shared/spinner/spinner.component.html
// module id = 863
// module chunks = 0